import routes from './routes';
import { SetRoutes } from 'components';

const LeasingPlansMainPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default LeasingPlansMainPage;
